(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var motionOK = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!motionOK) return;

    document.querySelectorAll('.collection-grid__items').forEach(function (grid) {
      var interval = parseInt(grid.dataset.rotateMs, 10) || 3500;

      grid.querySelectorAll('[data-carousel]').forEach(function (box, i) {
        var slides = box.querySelectorAll('.collection-tile__image');
        if (slides.length < 2) return;

        var index = 0;
        var timer = null;

        function advance() {
          slides[index].classList.remove('is-active');
          index = (index + 1) % slides.length;
          slides[index].classList.add('is-active');
        }

        // Stagger the starts so the tiles don't all flip on the same beat.
        function start() {
          if (timer) return;
          timer = setTimeout(function () {
            timer = setInterval(advance, interval);
          }, i * 600);
        }
        function stop() {
          clearTimeout(timer);
          clearInterval(timer);
          timer = null;
        }

        // Only run while the tile is actually on screen.
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
          }, { threshold: 0.25 }).observe(box);
        } else {
          start();
        }

        document.addEventListener('visibilitychange', function () {
          document.hidden ? stop() : start();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero-carousel]').forEach(function (carousel) {
    var slides = carousel.querySelectorAll('.hero__slide');
    if (slides.length < 2) return;
    var interval = parseInt(carousel.getAttribute('data-rotate-ms'), 10) || 6000;
    var current = 0;
    var dots = [];

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'hero__dots';
    slides.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'hero__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function () {
        goTo(i);
        if (timer) { clearInterval(timer); timer = setInterval(advance, interval); }
      });
      dots.push(dot);
      dotsWrap.appendChild(dot);
    });
    carousel.appendChild(dotsWrap);

    function goTo(index) {
      if (index === current) return;
      var prev = slides[current];
      var next = slides[index];
      prev.classList.remove('is-active');
      prev.setAttribute('aria-hidden', 'true');
      prev.setAttribute('tabindex', '-1');
      next.classList.add('is-active');
      next.removeAttribute('aria-hidden');
      next.removeAttribute('tabindex');
      dots[current].classList.remove('is-active');
      dots[index].classList.add('is-active');
      current = index;
    }
    function advance() {
      goTo((current + 1) % slides.length);
    }
    var timer = setInterval(advance, interval);
    carousel.addEventListener('mouseenter', function () { clearInterval(timer); timer = null; });
    carousel.addEventListener('mouseleave', function () {
      if (!timer) timer = setInterval(advance, interval);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
